
<template>

  <div class="lotti-my-children-module">

    <div class="lotti-module-title">{{ (leadView ? 'Alle' : 'Meine') }} Therapiekinder</div>

    <div class="lotti-module-nav">

      <el-button
          icon="el-icon-plus"
          type="success"
          @click="$router.push('child/0')"
          circle>
      </el-button>

      <el-input
          clearable
          size="medium"
          placeholder="Suchtext"
          v-model="searchForm.text">
      </el-input>

      <el-switch v-model="searchForm.archived" active-text="Archiv" active-color="rgb(158, 125, 255)"/>

      <el-button
          size="mini"
          class="lotti-search-info-popover"
          v-popover:popover-search-child
          round>
        ?
      </el-button>

      <el-popover
          ref="popover-search-child"
          placement="top-start"
          width="250"
          trigger="hover"
          content="Durchsuchbare Felder: Massnahme, Tel.Nr., Name, ID">
      </el-popover>

    </div>

    <el-table :data="tableData"
              class="lotti-module-table"
              ref="childTable"
              height="490px"
              stripe
              :row-key="tableData.id"
              :default-sort="searchForm.sortingParams"
              @sort-change="setSortingParams"
              @row-click="openChild"
              @hook:mounted="tableMounted"
              @hook:beforeDestroy="tableBeforeDestroy"
              style="width: 100%">

      <!--only dynamic with colum-->
      <el-table-column
          prop="name"
          label="Name"
          sortable="custom"
          :sort-orders="allowedSorting">
      </el-table-column>

      <el-table-column
          prop="gender"
          label="w/m"
          width="75px"
          sortable="custom"
          :sort-orders="allowedSorting">
        <template slot-scope="scope">
          <el-tag :type="scope.row.gender === true ? 'success' : 'primary'" style="font-size: 17px;">
            <i :class="scope.row.gender === true ? 'el-icon-male' : 'el-icon-female'"></i>
          </el-tag>
        </template>
      </el-table-column>

      <el-table-column
          prop="clarification_date"
          label="Abkl.Datum"
          sortable="custom"
          width="120px"
          :sort-orders="allowedSorting">
        <template slot-scope="scope">
          {{ datePickerHelper.formatUTCDateCH(scope.row.clarification_date) }}
        </template>
      </el-table-column>

      <el-table-column
          prop="birthday"
          label="Geb.Tag"
          sortable="custom"
          width="110px"
          :sort-orders="allowedSorting">
        <template slot-scope="scope">
          {{ datePickerHelper.formatUTCDateCH(scope.row.birthday) }}
        </template>
      </el-table-column>

      <el-table-column
          prop="telnr"
          width="140px"
          label="Tel.Nr."
          sortable="custom"
          :sort-orders="allowedSorting">
      </el-table-column>

      <el-table-column
          prop="action"
          label="Massnahme"
          width="130px"
          sortable="custom"
          :sort-orders="allowedSorting">
      </el-table-column>

    </el-table>

  </div>

</template>

<script>
import Vue from "../../main";
import auth from '../../auth.js';
import datePickerHelper from '../../Helpers/DatePickerHelper.js';

export default {

  props: {
    leadView: {
      type: Boolean,
      default: false
    },
  },

  data() {
    return {
      auth: auth,
      datePickerHelper: datePickerHelper,

      submitDelay: 400,//ms
      submitTimer: null,

      pageNumber: 0,
      tableData: [],
      thereIsMoreData: true,
      allowedSorting: ['ascending', 'descending'],
      tableSelector: '.lotti-my-children-module .el-table__body-wrapper',
      tableElement: null,

      searchForm: {
        text: '',
        archived: false,
        sortingParams: {
          prop: 'clarification_date',
          order: 'descending'
        }
      }
    }
  },

  methods: {

    setSortingParams(column, prop, order) {
      this.searchForm.sortingParams.prop = column.prop;
      this.searchForm.sortingParams.order = column.order;
    },

    openChild(row, event, column) {
      this.$router.push({
        name: 'child',
        params: {
          childId: row.id
        }
      })
    },

    getAllMyChildren() {

      //increase page number BEFORE submitting!
      this.pageNumber += 1;

      Vue.http.get(
          'api/v1/child/get-all-my',
          {
            params: {
              text: this.searchForm.text,
              archived: this.searchForm.archived,
              column: this.searchForm.sortingParams.prop,
              order: this.searchForm.sortingParams.order === 'ascending' ? 'asc' : 'desc',
              page: this.pageNumber,
              lead: this.leadView,
            }
          }
      ).then(response => {

        //concat the data at the end of the already loaded data if != null
        if (response.data) {
          this.tableData = this.tableData.concat(response.data);
        } else {
          //block further requests, there is no more data
          this.thereIsMoreData = false;
        }

      }, response => {
        // this.showError(response.data.message);
      })
    },

    resetTableLoader() {
      this.pageNumber = 0;//reset page size on filter change
      this.tableData = [];//reset tableData as well

      //allow loading for further data after reset
      this.thereIsMoreData = true;
    },

    sendDelayedSearchRequest() {
      //if timer exists: clear
      if(this.submitTimer) {
        clearTimeout(this.submitTimer);
        this.submitTimer = null;
      }
      this.submitTimer = setTimeout(() => {
        this.getAllMyChildren();
      }, this.submitDelay);
    },

    handleOnInfiniteScroll(event) {
      //implement infinite scroll
      if (
          this.thereIsMoreData &&
          Math.ceil(this.tableElement.clientHeight + this.tableElement.scrollTop) >= this.tableElement.scrollHeight
      ) {
        // you're at the bottom of the page
        this.getAllMyChildren();
      }
    },

    tableMounted() {
      //select table element first
      this.tableElement = document.querySelector(this.tableSelector);
      //add event listener secondly
      this.tableElement.addEventListener('scroll', this.handleOnInfiniteScroll);
    },

    tableBeforeDestroy() {
      this.tableElement.removeEventListener('scroll', this.handleOnInfiniteScroll);
    }
  },

  watch: {
    searchForm: {
      handler(newValue, oldValue) {
        this.resetTableLoader();//reset values on each form filter change
        this.sendDelayedSearchRequest();
      },
      deep: true,
    }
  },

  beforeMount() {

    //get all therapists in selected service
    this.getAllMyChildren();
  },

  mounted () {
  },

  beforeDestroy () {
  },
}

</script>